import NextPageWithServices from "@insightfulscience/smart-react/hocs/NextPageWithServices";
import { publicConfig } from "../config";
import storage from "./storage";
import gqlClient from "./gqlClient";
import recoveryService from "./recoveryService";
import storageService from "./storageService";
import subscriptionService from "./subscriptionService";
import routingService from "./routingService";
import { token } from "./storageService/token";
import { refreshToken } from "./storageService/refreshToken";
import { priceItem } from "./storageService/priceItem";
import { billingInfo } from "./storageService/billingInfo";

export const serviceCore = {
	publicConfig: () => publicConfig,
	storage,
	priceItem,
	billingInfo,
	token,
	refreshToken,
	storageService,
	recoveryService,
	gqlClient,
	routingService,
	subscriptionService,
};

export default NextPageWithServices(serviceCore);
